// Customer account self-service. Profile endpoints are scoped by bearer token.
import { apiClient, endpoints, unwrap } from '@core/api';

/** Account-level info (account-wide settings, payment options, etc.) */
export async function getAccountInfo() {
  const raw = await apiClient.get(endpoints.account.info);
  const { data } = unwrap(raw);
  return data ?? raw;
}

/** Customer profile (read). */
export async function getProfile() {
  const raw = await apiClient.get(endpoints.account.profile);
  const { data } = unwrap(raw);
  return data ?? raw;
}

/** Customer profile (update). */
export async function updateProfile(input) {
  return apiClient.patch(endpoints.account.profile, { data: input });
}

/**
 * The signed-in (B2B) customer's credit, and whether `amount` fits in it.
 * All money in minor units.
 * @param {{ amount?: number }} [params]
 */
export async function checkCredit({ amount } = {}) {
  const raw = await apiClient.get(endpoints.account.creditCheck, {
    query: { amount: Number.isFinite(amount) ? Math.round(amount) : undefined },
  });
  const { data } = unwrap(raw);
  const credit = data ?? raw ?? {};
  return {
    availableCredit: Number(credit.available_credit) || 0,
    creditLimit: Number(credit.credit_limit) || 0,
    outstandingAmount: Number(credit.outstanding_amount) || 0,
    reservedAmount: Number(credit.reserved_amount) || 0,
    requestedAmount: Number(credit.requested_amount) || 0,
    isEligible: credit.is_eligible !== false,
    reason: credit.reason || '',
  };
}

/** Change the signed-in customer's password. */
export async function changePassword({ currentPassword, newPassword, confirmPassword }) {
  return apiClient.post(endpoints.account.changePassword, {
    data: {
      old_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword ?? newPassword,
    },
  });
}
export async function deleteAccount() {
  return apiClient.delete(endpoints.account.profile);
}
